export default "__VITE_ASSET__W40FiXoS__"